// extracted by mini-css-extract-plugin
export default {"host":"style_host__z6oXg","icon":"style_icon__T6ZY7"};